import { render, staticRenderFns } from "./StripeBridgeSync.vue?vue&type=template&id=66604b4b&scoped=true"
import script from "./StripeBridgeSync.vue?vue&type=script&lang=js"
export * from "./StripeBridgeSync.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeSync.vue?vue&type=style&index=0&id=66604b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66604b4b",
  null
  
)

export default component.exports